import { render, staticRenderFns } from "./ProcessTrainRecord2.vue?vue&type=template&id=6ebe9187&scoped=true"
import script from "./ProcessTrainRecord2.vue?vue&type=script&lang=js"
export * from "./ProcessTrainRecord2.vue?vue&type=script&lang=js"
import style0 from "./ProcessTrainRecord2.vue?vue&type=style&index=0&id=6ebe9187&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebe9187",
  null
  
)

export default component.exports